var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton, BFormInput, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import { computed, ref } from "vue";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VaultSecret',
    props: {
        name: null,
        label: null,
        help: null,
        isSet: { type: Boolean }
    },
    emits: ["update"],
    setup(__props, { emit }) {
        const props = __props;
        const showEdit = ref(false);
        const secretValue = ref("");
        const editTitle = computed(() => `Edit ${props.label}`);
        const helpHtml = computed(() => markup(props.help, true));
        function onClick() {
            showEdit.value = true;
        }
        function onOk() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("update", props.name, secretValue.value);
            });
        }
        return { __sfc: true, props, showEdit, secretValue, editTitle, helpHtml, onClick, emit, onOk, BButton, BFormInput, BInputGroup, BInputGroupAppend };
    }
});
